<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <el-row>
          <div style="float: right">
            <OfSearch
              @search="search"
              style="float: left; margin-right: 10px"
              :placeholder="placeholder"
            ></OfSearch>
            <el-button
              size="small"
              icon="el-icon-search"
              type="danger"
              @click="loadData"
              >查询</el-button
            >
          </div>
        </el-row>
      </div>
      <div>
        <el-table
          border
          hightlight-current-row
          style="width: 100%"
          :header-cell-class-name="headerRow"
          :data="listData"
          :max-height="tableMaxHeight()"
          v-loading="isloading"
        >
          <el-table-column
          label="消息类型"
          align="center"
          width="100"
          >
            <template slot-scope="scope">
                {{scope.row.MessageType === 1?'开票消息':'其他'}}
            </template>
          </el-table-column>
          <el-table-column
            prop="Content"
            label="消息内容"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="UserName"
            label="发送人"
            align="center"
            width="120"
          ></el-table-column>
          <el-table-column label="创建时间" align="center" width="100">
            <template slot-scope="scope">
              {{ (scope.row.CreateTime * 1000) | formatDate2 }}
            </template>
          </el-table-column>
          <el-table-column label="是否已读" align="center" width="100">
            <template slot-scope="scope">
              {{ scope.row.IsRead ? '已读':'未读' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button
                v-access:read
                type="text"
                size="mini"
                @click="innerRead(scope.row)"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </div>
    </BasePage>
    <ModuleQuery
      v-if="formDataQuery"
      :dataForm="formData"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleQuery>
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page";
import OfSearch from "@/components/controls/of_search/of_search";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import ModuleQuery from "@/modules/zjrc/pages/basics/instation/query";
import { mapGetters } from "vuex";
import api from "@/modules/zjrc/api";

export default {
  name: "list",
  data() {
    return {
      isloading: false,
      listData: [],
      headerRow: "header-row",
      formVisible: false,
      formDataQuery: false,
      formTitle: "",
      formData: {},
      total: 0,
      currentPage: 1,
      pageSize: 15,
      searchModel: {},
      placeholder: "消息内容",
    };
  },
  methods: {
    innerRead(rowData) {
      this.formData = Object.assign({}, rowData);
      this.formTitle = "查看消息";
      this.formDataQuery = true;
    },
 //回调
    formCallBack(data) {
      this.formDataQuery = false;
      this.loadData();
    },
    //初始化数据
    loadData() {
      this.isloading = true;
      let params = {
        PageIndex: this.currentPage,
        PageSize: this.pageSize,
        SearchKey:
          this.searchModel.searchKey == null ? "" : this.searchModel.searchKey,
      };
      api.queryStationMessage(params).then((rep) => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          this.listData = rep.data.Data.rows;
        }
        this.isloading = false;
      });
    },
    //关键字查找
    search(keyword) {
      this.searchModel.searchKey = keyword;
      this.loadData();
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.currentPage = val;
        this.loadData();
      }
    },
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 250;
      }
      return tableMaxHeight;
    },
  },
  components: {
    BasePage,
    OfSearch,
    OfPagination,
    ModuleQuery
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped>
.el-date-editor >>> .el-input__icon {
  display: none;
}

/* .el-select >>> .el-input__inner {
  width: 120px;
} */
</style>

<style >
.searchbox {
  float: left;
  margin-right: 1%;
}
.searchbox_right {
  float: right;
  margin-right: 1%;
  widows: 100%;
}
</style>
